import React, { useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const localizer = momentLocalizer(moment);

const CalendarComponent = ({ events, setEvents, modalVisible, setModalVisible, newEvent, setNewEvent, handleAddEvent }) => {
  const [viewModalData, setViewModalData] = useState({ title: '', start: '', end: '' });
  const [viewModalVisible, setViewModalVisible] = useState(false);

  const handleEventClick = (event) => {
    setViewModalVisible(true);
    setViewModalData({
      title: event.title,
      start: moment(event.start).format('DD-MM-YYYY h:mm:ss A'),
      end: moment(event.end).format('DD-MM-YYYY h:mm:ss A'),
    });
  };

  const closeModal = () => {
    setViewModalVisible(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here, you can validate newEvent values before calling handleAddEvent
    handleAddEvent(newEvent);
  };

  return (
    <div style={{ height: '160vh' }}>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        onSelectEvent={handleEventClick}
        style={{ height: '150vh' }}
      />

      {viewModalVisible && (
        <div className="modal fade show" style={{ display: 'block' }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header bg-label-primary pb-3">
                <h5 className="modal-title">Event</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeModal}
                />
              </div>
              <div className="modal-body">
                <div className="row mb-3">
                  <div className="col-4">
                    <span className="fw-semibold">Event Title</span>
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">{viewModalData.title}</div>
                </div>
                <div className="row mb-3">
                  <div className="col-4">
                    <span className="fw-semibold">Start Date Time</span>
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">{viewModalData.start}</div>
                </div>
                <div className="row mb-3">
                  <div className="col-4">
                    <span className="fw-semibold">End Date Time</span>
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">{viewModalData.end}</div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {modalVisible && (
        <div className="modal fade show" style={{ display: 'block' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New Event</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalVisible(false)}
                />
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Event Title</label>
                    <input
                      type="text"
                      className="form-control"
                      value={newEvent.title}
                      onChange={(e) =>
                        setNewEvent({ ...newEvent, title: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Start Date & Time</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      value={newEvent.start}
                      onChange={(e) =>
                        setNewEvent({ ...newEvent, start: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">End Date & Time</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      value={newEvent.end}
                      onChange={(e) =>
                        setNewEvent({ ...newEvent, end: e.target.value })
                      }
                      required
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setModalVisible(false)}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Add Event
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalendarComponent;
